<template>
    <div class="location_selector" v-if="countries_list && countries_list.length > 0">
        <div class="country__wrapper" >
            <SearchAutocomplete
                    :items="countries_list"
                    :label="labelCountry"
                    ref="predpolCountryAutocomlete"
                    v-model="countryField"
                    :objectKey="countryKey"
                    :isDataUpdating="isDataUpdating"
                    @onChange="countryChange"
            ></SearchAutocomplete>
        </div>

				<Button @click="select_country">Добавить</Button>

        <div style="margin-top: 30px;">
            <Table
                    v-if="selected_countries.length > 0"
                    :data-source="selected_countries"
                    :columns="columns"
            >
                <template #bodyCell="{ column, record }">
                    <template v-if="column.key === 'name'">
												{{ record }}
                    </template>

                    <template v-if="column.key === 'action'">
                        <a @click="deleteItem(record)">Удалить</a>
                    </template>
                </template>
            </Table>
            <div v-else>Ничего не добавлено</div>
        </div>
    </div>
</template>
<script setup>
import {ref, defineProps, defineEmits, onMounted} from "vue";
import SearchAutocomplete from "@/components/Base/SearchAutocomplete.vue";
import axios from "axios";
import {Button, Table} from "ant-design-vue"

const props = defineProps({
  labelCountry: {
    default: "Выберите страну"
	},
  countryKey: {
    default: 'country'
	},
	modelValue: {
    default: []
	},
  //Данные обновляются в родительском компоненте
  isDataUpdating: {}
})

const emit = defineEmits(['onChange'])

let columns = ref([
  {
    title: 'Страна',
    dataIndex: 'name',
    key: 'name',
  },
  {
    title: 'Действия',
    dataIndex: 'action',
    key: 'action',
  },
])
let countries_list = ref([]);
let selected_countries = ref([]);
let countryField = ref('');

function select_country() {
  if (!selected_countries.value.includes(countryField.value)) {
    selected_countries.value.push(countryField.value);
	}
  countryField.value = '';
  emit('onChange', selected_countries.value)
}

function deleteItem(el) {
  let index = selected_countries.value.indexOf(el);

  if (index !== -1) {
    selected_countries.value.splice(index, 1);
  }
  emit('onChange', selected_countries.value)
}


async function get_countries_list() {
  selected_countries.value = props.modelValue

  const response = await axios.get('/get_all_countries', {
    headers: {
      'Accept': 'application/json',
    }
  })
    .catch(error => {
      console.log(error);
    });
  countries_list.value = response.data;
}
onMounted(async ()=>{
  await get_countries_list();
})
//

function countryChange() {
  //this.$emit('update:country', this.countryField);
  //this.$emit('onChange');
}
function isFieldRequired(key) {
  return false
}

</script>